export default __webpack_public_path__ + "assets/img/empty-avatar.27e6831d0477612b6c2e21dea2666829.png";